module.exports = __webpack_public_path__ + "static/media/logo-horus-negativo.bc7ca1b2.svg";